<template>
    <div>
        <licences 
            :licenses="totalProductsLicences"
            :enableSupport="false"
            class="mb-6">
        </licences>

        <staffs class="mt-4" :isReadOnly="true">
            <template #header>
                <h2 class="mt-4">
                    {{ $l10n.__('Attribution des licences') }}
                </h2>
                <p class="lh-20 mt-0 mb-4 fs-3">
                    <span v-html="totalLabel"></span>
                    <br>
                    <span class="gray-60">{{ $l10n.__('Les licences ont été attribuées en fonction des besoins de vos collaborateurs afin qu’ils puissent utiliser les différents modules proposés dans Sellsy.') }}</span>
                </p>
            </template>
        </staffs>
    </div>

</template>

<script>
import Licences from "vcomponents/sellsyaccountmanager/Licences.vue";
import Staffs from 'vcomponents/pages/account/Staffs.vue';

import { createNamespacedHelpers } from 'vuex';
const renewCart = createNamespacedHelpers('renewCart');

export default {
    computed: {
        ...renewCart.mapGetters([
            'totalProductsLicences',
            'staffTotal',
        ]),
        totalLabel() {
            return  this.$l10n.n__('Votre offre compte %(count)s licence au total', 'Votre offre compte %(count)s licences au total', this.staffTotal, { count: `<strong>${this.totalProductsLicences.reduce((acc, val) => acc + val.total, 0)}</strong>`})
        }
    },
    components: {
        Licences,
        Staffs,
    },
};
</script>